import React, { useState } from "react";
import classes from "./ContactPage.module.css";
import { FaRegCalendarPlus, FaWhatsapp } from "react-icons/fa";
import { MdOutlineEmail } from "react-icons/md";

import { Button, Dropdown, Heading, Input } from "../../components/common";
const countries = ["USA", "UK"];
const businessTypes = ["Sales", "Support", "General Enquiry"];
const ContactPage = () => {
  const [fullName, setFullName] = useState("");
  const [email, setEmail] = useState("");
  const [message, setMessage] = useState("");
  const [phoneNumber, setPhoneNumber] = useState("");
  const [companyName, setCompanyName] = useState("");
  const [showCountryDropdown, setShowCountryDropdown] = useState("");
  const [selectedCountry, setSelectedCountry] = useState("");
  const [showBusinessTypeDropdown, setShowBusinessTypeDropdown] = useState("");
  const [selectedBusinessType, setSelectedBusinessType] = useState("");

  return (
    <div className={classes.wrapper}>
      <Heading xl4 font600 className={classes.heading}>
        Drop a message for us, we’ll get back to you
      </Heading>{" "}
      <div className={classes.container}>
        <div className={classes.inputWrapper}>
          <Input
            type="text"
            value={fullName}
            setValue={setFullName}
            placeholder="Full name"
          />{" "}
          <Input
            type="email"
            value={email}
            setValue={setEmail}
            placeholder="Email"
          />
          <div className={classes.inputContainer}>
            {" "}
            <Dropdown
              items={countries}
              isActive={showCountryDropdown}
              setIsActive={setShowCountryDropdown}
              selectedValue={selectedCountry}
              onSelect={(val) => setSelectedCountry(val)}
              placeholder="Country"
            />{" "}
            <Input
              type="tel"
              value={phoneNumber}
              setValue={setPhoneNumber}
              placeholder="Phone Number"
            />
          </div>
          <div className={classes.inputContainer}>
            <Input
              type="text"
              value={companyName}
              setValue={setCompanyName}
              placeholder="Company"
            />
            <Dropdown
              items={businessTypes}
              isActive={showBusinessTypeDropdown}
              setIsActive={setShowBusinessTypeDropdown}
              selectedValue={selectedBusinessType}
              onSelect={(val) => setSelectedBusinessType(val)}
              placeholder="Enquiry Type"
            />
          </div>
          <textarea
            className={classes.message}
            name="message"
            id="message"
            rows={3}
            cols={3}
            placeholder="Detail message"
            value={message}
            onChange={(e) => setMessage(e.target.value)}
          ></textarea>
          <Button wFull onClick={() => { }}>
            Submit
          </Button>
        </div>
        <div className={classes.infoContainer}>
          <Heading base textWhite semiBold className={classes.title}>
            Get in touch
          </Heading>
          <a
            href="mailto:info@solidhash.io"
            rel="noreferrer"
            className={classes.item}
          >
            {" "}
            <div className={classes.socialIconContainer}>
              <MdOutlineEmail className={classes.socialIcon} />
            </div>
            info@solidhash.io
          </a>
          <a
            href="#/"
            target="_blank"
            rel="noreferrer"
            className={classes.item}
          >
            {" "}
            <div className={classes.socialIconContainer}>
              <FaRegCalendarPlus className={classes.socialIcon} />
            </div>{" "}
            Book a Meeting
          </a>{" "}
          <a
            href="#/"
            target="_blank"
            rel="noreferrer"
            className={classes.item}
          >
            <div className={classes.socialIconContainer}>
              <FaWhatsapp className={classes.socialIcon} />
            </div>{" "}
            Whatsapp
          </a>
        </div>
      </div>
    </div>
  );
};

export default ContactPage;
